// app/middleware/notFoundItaly.ts

export default defineNuxtRouteMiddleware((from, to) => {
  if (to.params.region === "italia") {
    throw createError({ statusCode: 404 });
  }
});
